import DoktorIcon from "@/layout/DoktorIcons"
import { cn } from "@/utils/utils"
import { JSX } from "react"

type IconCircleProps = {
  /** A DoktorIcon name (every CMS icon field is backed by the `icons` datasource), or ready-made content such as a step number. */
  icon?: string | JSX.Element
  /** Pixel size of the inner icon. Overridden by iconClassName. */
  iconSize?: number
  /** Extra classes for the circular container (e.g. a different background). */
  className?: string
  /** Classes for the inner icon — use for responsive sizing (CSS wins over iconSize). */
  iconClassName?: string
}

export const IconCircle = ({ icon, iconSize = 32, className, iconClassName }: IconCircleProps) => (
  <div
    className={cn("flex h-[70px] w-[70px] shrink-0 items-center justify-center rounded-full bg-primary-05", className)}
  >
    {typeof icon === "string" ? (
      <DoktorIcon iconName={icon} width={iconSize} height={iconSize} className={iconClassName} />
    ) : (
      icon
    )}
  </div>
)
